// sl-SI number formatting (decimal comma).
const cache = new Map<number, Intl.NumberFormat>();

export function fmt(v: number | null | undefined, d = 0): string {
  if (v === null || v === undefined || !Number.isFinite(v)) return '–';
  let f = cache.get(d);
  if (!f) { f = new Intl.NumberFormat('sl-SI', { minimumFractionDigits: d, maximumFractionDigits: d }); cache.set(d, f); }
  return f.format(v + 0 === 0 ? 0 : v);
}

const SMALL = new Set(['pri', 'na', 'ob', 'v', 'pod', 'nad', 'za', 'pred', 'in', 'od', 'do', 'k', 'h', 's', 'z']);

/** "MARIJA DOBJE" → "Marija Dobje", "ŠENTJUR PRI CELJU" → "Šentjur pri Celju". */
export const titleCase = (s: string) => s.toLocaleLowerCase('sl').split(' ')
  .map((w, i) => (i > 0 && SMALL.has(w) ? w : w.replace(/(^|-)(\p{L})/gu, (_, a: string, b: string) => a + b.toLocaleUpperCase('sl'))))
  .join(' ');
